<template>
  <b-container>
    <b-overlay 
      variant="dark"
    >
      <b-card title="Toewijzen herinspecties">
        <inspectie-stap
          :activiteit="planning"
          @update:activiteit="planning = $event"
        />
        
        <b-button 
          variant="ghost" 
          class="pull-right" 
          size="lg"
          @click="getLijst"
        >
          <i class="fa fa-refresh mx-1" />
        </b-button>
          
        <b-pagination
          v-model="currentPage"
          :total-rows="filteredUnits.length"
          :per-page="perPage"
          pills
          limit="20"
          aria-controls="my-table"
        />

        <b-input 
          v-model="zoekterm" 
          size="lg" 
          debounce="500"
          placeholder="Zoeken..."
        />

        <b-form-group>
          <b-input-group 
            :append="aantalmaanden.toString()" 
            prepend="Aantal maanden"
          >
            <b-input 
              v-model="aantalmaanden" 
              :max="33" 
              :min="12" 
              type="range"
            />
          </b-input-group>
        </b-form-group>

        <b-table 
          :items="filteredUnits" 
          :busy="busy"
          :current-page="currentPage"
          :fields="['unit','laatsteInspectie','relatie','onderhoudsfirma','voor','toegewezenAan']"
          :tbody-tr-class="rowClass"
          :per-page="perPage"
          :caption="`Units verdwijnen pas van deze lijst wanneer de laatste inspectie datum niet meer buiten de ${aantalmaanden} maanden valt`"
          caption-top
          striped
          dark
          select-mode="range"
          selectable
          @row-selected="onRowSelected"
        >
          <template #cell(unit)="row">
            {{ row.item.un }} {{ row.item.ad }} {{ row.item.wp }}
          </template>
          <template #cell(onderhoudsfirma)="row">
            {{ row.item.of }}
          </template>
          <template #cell(laatsteInspectie)="row">
            {{ moment(row.item.ld).format('L') }} ({{ row.item.am }})
          </template>
          <template #cell(relatie)="row">
            {{ row.item.re }}
          </template>
          <template #cell(voor)="row">
            {{ row.item.da == null ? moment(row.item.dl).fromNow() : moment(row.item.da).format('L') }}
            <b-button 
              v-if="row.item.in != ''" 
              @click="deleteTaak(row.item)"
            >
              verwijderen
            </b-button>
          </template>
          <template #cell(toegewezenAan)="row">
            {{ row.item.in }}
          </template>
        </b-table>

        <b-button 
          :disabled="isDisabled"
          variant="success"
          size="lg"
          class="float-right" 
          @click="planInspecties"
        >
          Plan {{ unitids.length }} herinspecties
        </b-button>
      </b-card>
    </b-overlay>
  </b-container>
</template>
<script>
import { serviceMixin } from "@/mixins/serviceMixin";
import InspectieStap from '../../../components/trajecten/InspectieStap.vue';
export default {
    name: 'HerinspectiesOverzicht',
    components: {InspectieStap},
    mixins: [ serviceMixin ],
    props: {
    },
    data() {
        return  {
          zoekterm: null,
          currentPage: 1,
          perPage: 100,
          geselecteerd: [],
          aantalmaanden: 33,
          units: [],
          busy: false,
          userOverview: null,
          planning: {
            toegewezen_aan: null,
            deadline: null,
            gecontroleerd_door: null ,
            omschrijving: ''
        }
        }
    },
    computed: {
      filteredUnits: function() {
        return this.units.filter(u => JSON.stringify(u).toLowerCase().includes(this.zoekterm) && u.am > this.aantalmaanden)
      },
      isDisabled: function () {
        if (this.unitids.length == 0) return true
        if (this.planning.toegewezen_aan == null) return true
        if (this.planning.gecontroleerd_door == null) return true
        if (this.planning.deadline == null) return true
        return false
      },
      unitids: function () {
        return this.geselecteerd.filter((u) => u.in === '').map(u2 => u2.id)
      }
    },
    watch: {},
    mounted () {
        this.getLijst();
    },
    methods: {
      rowClass(item, type) {
        if (!item || type !== 'row') return
        if (item.in != '') return 'table-dark'
      },
      onRowSelected(items) {
        this.geselecteerd = items;
      },
      planInspecties() {
        var vm = this;
        vm.busy = true;
        var postData = {...this.planning,unitids: this.unitids};
        console.log(postData);
        this.post('/inspecties/herinspecties', postData).then(response => console.log(response))
        .finally(() => {
          vm.busy = false;
          vm.getLijst();
        })
      },
      deleteTaak(taak) {
      var vm = this
      console.log(taak);
      var postData = {
        data: {
          type: 'Herinspectie', 
          id: taak.ti} // taak id
      };
      console.log(postData);
      this.deletePost('/inspecties/herinspecties',{payload: postData})
      .then(() => {
        vm.getLijst()
      });
      },
      getUserOverview() {
        // TODO dynamic year
         var vm = this;
        this.get('/user/profile/overview/2022').then(response => vm.userOverview = response.data.result)
        .finally(() => vm.busy = false)
      },
      getLijst() {
        var vm = this;
        vm.busy = true
        this.get('/inspecties/herinspecties').then(response => vm.units = response.data)
        .finally(() => vm.busy = false)
      }
    },
}
</script>